// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gbQP","questions":"styles_questions__CZuKY","footer":"styles_footer__39gX7"};